import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { Trans } from 'react-i18next'

class CustomModalComponent extends Component {
  /**
   * Close Modal action.
   */
  handleClose = () => {
    const { active } = this.props

    this.props.actionOnClickClose(active)
  }

  /**
   * Accept Modal action.
   */
  handleAccept = () => {
    const { active } = this.props

    this.props.actionOnClickAccept(active)
  }

  /**
   * Render.
   *
   * @return {XML}
   */
  render() {
    const { title, subtitle, body, active } = this.props

    return (
      <div className="static-modal">
        <Modal show={active} onHide={this.handleClose} backdropClassName="modal-backdrop-extra">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
            {subtitle !== undefined && <h5 className="subtitle">{subtitle}</h5>}
          </Modal.Header>

          {body !== undefined && <Modal.Body>{body}</Modal.Body>}

          <Modal.Footer>
            <div className="pull-right">
              <button className="btn btn-secondary" onClick={this.handleClose}>
                <Trans>Cancelar</Trans>
              </button>
              <button className="btn btn-primary" onClick={this.handleAccept}>
                <Trans>Confirmar</Trans>
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default CustomModalComponent
